import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { mainColor } from 'theme/Theme';
import './index.css';
import { App } from './App';
import * as serviceWorker from './serviceWorker';
import { store } from './store/store';

ReactDOM.render(
  <Provider store={store}>
    <Suspense
      fallback={
        <AppBar>
          <Toolbar style={{ backgroundColor: mainColor, paddingLeft: 0, paddingRight: 0 }} />
        </AppBar>
      }
    >
      <App />
    </Suspense>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
